export const t27 = [

  {
    id: 1,
    name: "Pranadeep Reddy",
    position: "Technical Member",
    alt: "Pranadeep Reddy",
    image: "Team/t27/Pranadeep.jpeg",
    socials: {
      github: "https://github.com/pranadeep1",
      instagram: "https://www.instagram.com/pranadeepreddy",
      linkedin: "https://www.linkedin.com/in/pranadeep-reddy-943128284",
    },
  },
  {
    id: 2,
    name: "GVNSS.Vignesh",
    position: "Technical Member",
    alt: "Vignesh",
    image: "Team/t27/Vignesh.jpeg",
    socials: {
      github: "https://github.com/Vignesh777777",
      instagram: "https://www.instagram.com/gvnss_vignesh",
      linkedin: "https://www.linkedin.com/in/vignesh-gazula-211539293",
    },
  },
  {
    id: 3,
    name: "Srinivas",
    position: "Technical Member",
    alt: "Srinivas",
    image: "Team/t27/srinivas.jpg",
    socials: {
      github: "",
      instagram: "",
      linkedin: "",
    },
  },
  {
    id: 4,
    name: "Satwik Raj",
    position: "Technical Member",
    alt: "Geethika",
    image: "Team/t27/Sathwik Raj.jpeg",
    socials: {
      github: "https://github.com/vajjipartisatwikraj",
      instagram: "https://www.instagram.com/vajjiparti_satwikraj",
      linkedin: "https://www.linkedin.com/in/satwik-raj-vajjiparti-24b2152a4",
    },
  },
  {
    id: 5,
    name: "Ashutosh",
    position: "Technical Member",
    alt: "Ashutosh",
    image: "Team/t27/Ashutosh.jpg",
    socials: {
      github: "https://github.com/Ashutosh3678",
      instagram: "https://www.instagram.com/mr_ash1805?igsh=MjRlaHZtdXJ2dHVp",
      linkedin:
        "https://www.linkedin.com/in/%C3%A3shutosh-si%C3%B1gh-5b363220a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
  },
  {
    id: 6,
    name: "Assis Mohanty",
    position: "Technical Member",
    alt: "Assis Mohanty",
    image: "Team/t27/Assis.jpg",
    socials: {
      github: "https://github.com/Assis-Mohanty",
      instagram: "",
      linkedin: "https://www.linkedin.com/in/assis-mohanty-668269238/",
    },
  },
  {
    id: 7,
    name: "Venkata Charan",
    position: "Technical Member",
    alt: "Venkata Charan",
    image: "Team/t27/venkata charan .jpeg",
    socials: {
      github: "",
      instagram: "",
      linkedin: "",
    },
  },
  {
    id: 8,
    name: "Sai Sree",
    position: "Technical Member",
    alt: "Sai Sree",
    image: "Team/t27/sai sree.jpeg",
    socials: {
      github: "",
      instagram: "",
      linkedin: "",
    },
  },
  {
    id: 9,
    name: "Jai Bharath Reddy",
    position: "Graphic Designer",
    alt: "Jai Bharath Reddy",
    image: "Team/t27/Bharath.jpg",
    socials: {
      github: "https://github.com/jbreddy1",
      instagram:
        "https://www.instagram.com/.jaibharath.?igsh=MWVneHM1bGU0em13ag==",
      linkedin:
        "https://www.linkedin.com/in/jai-bharath-reddy-rajula-8262142a4?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",

    },
  },
  {
    id: 10,
    name: "Meghana",
    position: "Graphic Designer",
    alt: "Meghana",
    image: "Team/t27/Meghana.jpg",
    socials: {
      github: "https://github.com/Kmeghana2006",
      instagram: "https://www.instagram.com/meghaaa_3_?igsh=YW1xamZ6ejNxODUy",
      linkedin: "https://www.linkedin.com/in/k-meghana-605247324?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
  },
  {
    id: 15,
    name: "Priya",
    position: "Operations",
    alt: "Priya",
    image: "Team/t27/Priya.jpeg",
    socials: {
      github: "https://github.com/priyaa-0605",
      instagram: "https://www.instagram.com/priyaa_0605",
      linkedin: "https://www.linkedin.com/in/priyaa-veerabathini-81623a2b7",
    },
  },
  {
    id: 11,
    name: "Karthik Reddy",
    position: "Content Writer",
    alt: "Karthik Reddy",
    image: "Team/t27/Karthik Reddy.jpeg",
    socials: {
      github: "https://github.com/karthikreddynyalapatla",
      instagram: "https://www.instagram.com/karthikreddyn._",
      linkedin: "https://www.linkedin.com/in/karthik-reddy-nyalapatla-0833172b1",
    },
  },
  {
    id: 12,
    name: "Harshith Reddy",
    position: "Promotions",
    alt: "Harshith Reddy",
    image: "Team/t27/Harshith.jpeg",
    socials: {
      github: "https://github.com/Harshithgreek",
      instagram: "https://www.instagram.com/mr_h_a_r_s_h_a_1",
      linkedin: "https://www.linkedin.com/in/harshith-reddy-bandla-28b2942b6",
    },
  },
  {
    id: 13,
    name: "Jyoti",
    position: "Promotions",
    alt: "Jyoti",
    image: "Team/t27/jyoti.jpeg",
    socials: {
      github: "",
      instagram: "",
      linkedin: "",
    },
  },
  {
    id: 14,
    name: "Pravallika",
    position: "Promotions",
    alt: "Pravallika",
    image: "Team/t27/Pravallika.jpeg",
    socials: {
      github: "https://github.com/J-Pravalika",
      instagram: "https://www.instagram.com/_pravalika.j_",
      linkedin: "https://www.linkedin.com/in/pravalika-j-169990320",
    },
  },
  {
    id: 17,
    name: "Suvarna",
    position: "Promotions",
    alt: "Suvarna",
    image: "Team/t27/suvarna.jpg",
    socials: {
      github: "",
      instagram: "",
      linkedin: "",
    },
  },
  {
    id: 16,
    name: "Vaishnavi",
    position: "Photography",
    alt: "Vaishnavi",
    image: "Team/t27/vyshnavi.jpeg",
    socials: {
      github: "",
      instagram: "",
      linkedin: "",
    },
  },
  {
    id: 18,
    name: "Preetham",
    position: "Video Editing",
    alt: "Preetham",
    image: "Team/t27/Preetham.jpg",
    socials: {
      github: "",
      instagram: "https://www.instagram.com/preethamx5105/",
      linkedin: "https://www.linkedin.com/in/preetham-p-210564348?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app ",
    },
  },
];
